"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var propTypes = {
  /** class name applied to anchor tag */
  className: _propTypes["default"].string,
  /** Product label */
  label: _propTypes["default"].string.isRequired,
  /** Icon name from Anypoint Icons `Icon` component  */
  icon: _propTypes["default"].string.isRequired,
  /** URL for product heading */
  href: _propTypes["default"].string,
  /** Called when product name is clicked. This overrides the `href` prop and
      can be used with a router hook. */
  onClick: _propTypes["default"].func,
  /** id to put on the element for an automation test */
  testId: _propTypes["default"].string,
  /** Theming object of css classes */
  theme: _propTypes["default"].shape({
    icon: _propTypes["default"].string,
    text: _propTypes["default"].string
  })
};

/**
 * The primary navigation element within an Anypoint product.
 */
var SidebarProductHeading = exports["default"] = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(SidebarProductHeading, _React$Component);
  function SidebarProductHeading() {
    (0, _classCallCheck2["default"])(this, SidebarProductHeading);
    return _callSuper(this, SidebarProductHeading, arguments);
  }
  (0, _createClass2["default"])(SidebarProductHeading, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        className = _this$props.className,
        label = _this$props.label,
        icon = _this$props.icon,
        href = _this$props.href,
        onClick = _this$props.onClick,
        testId = _this$props.testId,
        _this$props$theme = _this$props.theme,
        theme = _this$props$theme === void 0 ? {} : _this$props$theme;
      var handleOnClick = function handleOnClick(e) {
        if (onClick) {
          e.preventDefault();
          onClick();
        }
      };
      return (
        /*#__PURE__*/
        // eslint-disable-next-line jsx-a11y/href-no-hash
        _react["default"].createElement("a", {
          href: href || '#',
          onClick: handleOnClick,
          className: (0, _classnames["default"])(theme['sidebar-product-heading'], className),
          "data-test-id": testId,
          "data-anypoint-component": "SidebarProductHeading"
        }, icon && /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
          className: theme.icon,
          name: icon,
          size: "",
          isDecorative: true
        }), /*#__PURE__*/_react["default"].createElement("span", {
          className: theme.text
        }, label))
      );
    }
  }]);
  return SidebarProductHeading;
}(_react["default"].Component);
SidebarProductHeading.displayName = 'SidebarProductHeading';
SidebarProductHeading.propTypes = propTypes;
//# sourceMappingURL=SidebarProductHeading.js.map